import React from 'react';

import { ContactSupport } from '@neptune/shared/common-ui';
import { Icon, Layout, Modal, Text } from '@neptune/shared/venus-ui';

import ConfirmationModal from 'components/confirmation-modal/ConfirmationModal';

type CancelSubscriptionModalProps = {
  onCancelSubscription(): void;
};

export const CancelSubscriptionModal: React.FC<CancelSubscriptionModalProps> = ({
  onCancelSubscription,
}) => {
  return (
    <ConfirmationModal
      type="cancelSubscription"
      title="Delete account"
      confirmButtonText="Ok, delete my account"
      cancelButtonText="Keep my account"
      onConfirm={onCancelSubscription}
    >
      <Layout.Row spacedChildren="md">
        <Modal.Text>
          <Icon size="lg" fixedWidth glyph="trash" color="error" />
        </Modal.Text>
        <Modal.Text>
          If you delete your account, you{' '}
          <Text color="error">can&apos;t create a new one using the same email address</Text>. If
          you need to change your username, contact{' '}
          <ContactSupport type="secondary" fontWeight="normal" external>
            Neptune Support
          </ContactSupport>{' '}
          instead of deleting your account.
        </Modal.Text>
      </Layout.Row>
    </ConfirmationModal>
  );
};
